module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.certificationProcess.status <= 6) ? _c('md-layout', {
    key: "syncInformations"
  }, [(_vm.queueStatus === 'creating') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("CARREGANDO INFORMAÇÕES")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Esta é a ultima etapa do processo de certificação do banco de leite\n        humano, nesta etapa você precisa manter o WI-FI do seu celular ligado\n        até que o envio esteja concluído.")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.queueLog))]), _vm._v(" "), _c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : (_vm.queueStatus === 'waiting') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("ENVIO DAS INFORMAÇÕES")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Esta é a ultima etapa do processo de certificação do banco de leite\n        humano, nesta etapa você precisa manter o WI-FI do seu celular ligado\n        até que o envio esteja concluído.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    attrs: {
      "disabled": !_vm.networkStatus
    },
    on: {
      "click": _vm.startQueue
    }
  }, [_vm._v("Iniciar a Sincronização\n      ")])], 1) : (_vm.queueStatus === 'running') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("ENVIANDO FOTOS PARA NUVEM")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Durante esse processo mantenha o aplicativo aberto e WI-FI\n        ligado.")]), _vm._v(" "), _c('md-progress', {
    staticClass: "md-warn",
    attrs: {
      "md-size": 150,
      "md-progress": _vm.progress
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.queueLog) + " "), _c('br'), _vm._v("\n        Total: " + _vm._s(_vm.queue.size) + " Pendente: " + _vm._s(_vm.queue.pending)), _c('br'), _vm._v("\n        Area Atual: " + _vm._s(_vm.currentArea)), _c('br'), _vm._v("\n        Item Atual: " + _vm._s(_vm.currentItem)), _c('br'), _vm._v("\n        Foto Atual: " + _vm._s(_vm.currentPhoto) + "\n      ")])], 1) : (_vm.queueStatus === 'error') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("OCORREU UM ERRO AO ENVIAR OS DADOS PARA A NUVEM!")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Verifique os motivos abaixo antes de tentar novamente.")]), _vm._v(" "), _c('md-list', {
    staticClass: "custom-list md-triple-line"
  }, [_vm._l((_vm.faultyPhotos), function(object, key) {
    return _c('md-list-item', [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(object.item.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v("FOTO: " + _vm._s(object.photo.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(object.error))])]), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-list-action",
      on: {
        "click": function($event) {
          return _vm.captureNewPhoto(object)
        }
      }
    }, [_c('md-icon', {
      staticClass: "md-primary"
    }, [_vm._v("upload_file")])], 1), _vm._v(" "), _c('md-divider', {
      staticClass: "md-inset"
    })], 1)
  }), _vm._v(" "), (_vm.blueprintError != '') ? _c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("PLANTA BAIXA DO BLH")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.blueprintError))])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        return _vm.captureNewBlueprint()
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("upload_file")])], 1), _vm._v(" "), _c('md-divider', {
    staticClass: "md-inset"
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    attrs: {
      "disabled": !_vm.networkStatus
    },
    on: {
      "click": _vm.restartQueue
    }
  }, [_vm._v("Tentar a Sincronização Novamente\n      ")])], 1) : _vm._e()], 1) : _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Parabéns!\n      "), _c('b', [_vm._v(_vm._s(_vm.blh.name))])]), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("CERTIFICAÇÃO " + _vm._s(_vm.blh.currentYear) + " ENVIADA COM SUCESSO!")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Seu processo está em fase de análise, qualquer dúvida entre em contato\n      conosco")])]), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": Infinity
    }
  }, [_c('span', [_vm._v("Sem conexão com a internet! Conecte a uma rede wi-fi e tente novamente.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49695c0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SyncQueue.vue
// module id = 832
// module chunks = 1